<template>
  <ul class="navigation__list">
    <slot></slot>
  </ul>
</template>

<script>
export default {
  name: "NavigationList",
};
</script>

<style lang="scss" scoped>
.navigation__list {
  margin: 0px;
  padding: 0px;
}
</style>
